module.exports = __webpack_public_path__ + "static/media/gcp_brandmark.ff0ffb9c.svg";